export default __webpack_public_path__ + "static/mnjit_blur-686e34b3e939dc8777128fbe0b4bf8cd.png";